import React, { useState, useEffect } from 'react'
import Alert from '@material-ui/lab/Alert'
import { Snackbar } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import { translateError } from '../util/utils'
import { showAlert } from '../../redux/actions/actions'
import { ALERT_TYPE_ERROR, ALERT_TYPE_INFO, ALERT_TYPE_SUCCESS } from './custom-alert-constants'
import InternationalizedFormattedText from '../util/internationalized-formatted-text'
import { ERROR_CODE_DEFAULT_STATE, ERROR_MESSAGE_TIMEOUT } from '../../utils/constants'

const CustomAlert = () => {
  const dispatch = useDispatch()

  const showFail = useSelector((state) => state.reducer.showFail)
  const showSuccess = useSelector((state) => state.reducer.showSuccess)
  const storedCode = useSelector((state) => state.reducer.code)
  const storedMessage = useSelector((state) => state.reducer.errorMessage)

  const vertical = 'top'
  const horizontal = 'center'

  const [severity, setSeverity] = useState(ALERT_TYPE_INFO)
  const [show, setShow] = useState(showFail || showSuccess)
  const [code, setCode] = useState(ERROR_CODE_DEFAULT_STATE)

  const handleClose = () => {
    dispatch(showAlert(false, false, ERROR_CODE_DEFAULT_STATE, undefined))
    setShow(false)
    setSeverity(ALERT_TYPE_INFO)
  }

  useEffect(() => {
    if (!!storedMessage) {
      setCode(storedMessage)
      return
    }

    const error = translateError(storedCode)
    setCode(error ?? ERROR_CODE_DEFAULT_STATE)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showFail, showSuccess, storedCode])

  useEffect(() => {
    setShow(showFail || showSuccess)
    setSeverity(showFail ? ALERT_TYPE_ERROR : showSuccess ? ALERT_TYPE_SUCCESS : ALERT_TYPE_INFO)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [code])

  return (
    <Snackbar
      anchorOrigin={{ vertical, horizontal }}
      open={!!show}
      onClose={handleClose}
      key={vertical + horizontal}
      autoHideDuration={ERROR_MESSAGE_TIMEOUT}
    >
      {!!show && !!code && code !== ERROR_CODE_DEFAULT_STATE ? (
        <Alert severity={severity}>
          <InternationalizedFormattedText id={code} variant='body2' />
        </Alert>
      ) : null}
    </Snackbar>
  )
}

export default CustomAlert
